import React, {Fragment, useRef} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Select, Chip_input, Explanation_text} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import axios from 'axios';

export default function Notification_setup_popup(props){


  function onSubmit(params){
    params.task_reminders_time=adjustFromTimezone(params.task_reminders_time);
    axios.put('/api/notificationSetup', params).then(()=>{
      window.location.href='/setup';
    })
  }

  function adjustForTimezone(hour){
    let time_diff=-new Date().getTimezoneOffset()/60;
    let nh=hour+time_diff;
    if(nh<0){nh=24+nh;}
    else if(nh>24){nh=0+nh;}
    return nh;
  }

  function adjustFromTimezone(hour){
    let time_diff=new Date().getTimezoneOffset()/60;
    let nh=hour+time_diff;
    if(nh<0){nh=24+nh;}
    else if(nh>24){nh=0+nh;}
    return nh;
  }

  let initial_values={};
  initial_values.task_reminders_time=adjustForTimezone(props.workspace.task_reminders_time);
  initial_values.task_reminders_summary=props.workspace.task_reminders_summary
  initial_values.task_reminders_priority=(props.workspace.task_reminders_priority==undefined || props.workspace.task_reminders_priority==1)?4:props.workspace.task_reminders_priority;
  initial_values.task_reminders_admin_all_tasks=props.workspace.task_reminders_admin_all_tasks;
  return(
    <Form
      onSubmit={onSubmit}
      initialValues={initial_values}
      mutators={{
        ...arrayMutators
      }}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup handleClose={props.handleClose} always_open accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose()}} title='notification_setup_title' content={
          <div style={{width:'95vw', maxWidth:'600px'}}>
            <div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px', marginBottom:'20px'}}><Field name='task_reminders_summary'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}/>} label={<Explanation_text inline text="Task reminder summary"/>}/>}</Field></div>
            {(props.workspace!=undefined && props.workspace.admin==true)?<div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px', marginBottom:'20px'}}><Field name='task_reminders_admin_all_tasks'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}/>} label={<Explanation_text inline text="Task reminder for tasks assigned to any team member"/>}/>}</Field></div>:null}
            <div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px', marginBottom:'20px'}}><Grid container>
            <Grid item xs={6}><Select title='Task reminder time' variant='not_outlined' color='transparent' name='task_reminders_time' select_data={[{id:1, name:'01:00'}, {id:2, name:'02:00'}, {id:3, name:'03:00'}, {id:4, name:'04:00'}, {id:5, name:'05:00'}, {id:6, name:'06:00'}, {id:7, name:'07:00'}, {id:8, name:'08:00'}, {id:9, name:'09:00'}, {id:10, name:'10:00'}, {id:11, name:'11:00'}, {id:12, name:'12:00'}, {id:13, name:'13:00'}, {id:14, name:'14:00'}, {id:15, name:'15:00'}, {id:16, name:'16:00'}, {id:17, name:'17:00'}, {id:18, name:'18:00'}, {id:19, name:'19:00'}, {id:20, name:'20:00'}, {id:21, name:'21:00'}, {id:22, name:'22:00'}, {id:23, name:'23:00'}, {id:24, name:'24:00'}]}/></Grid></Grid></div>
          </div>
        }/>
        </form>
      )}
      
    </Form>
  )
}
